import type { GeneratedContent } from "@/api/twitter";
import type { Persona } from "@/api/personas";
import { TwitterAvatar } from "@/components/twitter/TwitterAvatar";

export const ReadOnlyTweetCard = ({
  tweet,
  personaData,
}: {
  tweet: GeneratedContent;
  personaData: Persona;
}) => {
  const dateToDisplay = tweet.date ? new Date(tweet.date) : new Date();
  const localDate = dateToDisplay.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    year: "numeric",
    hour12: true,
  });

  return (
    <div className="border rounded-2xl p-6">
      <div className="flex justify-between items-center">
        <div className="w-full flex flex-row justify-between items-center mb-2">
          <TwitterAvatar persona={personaData} />
        </div>
      </div>

      <p className="text-sm italic">
        {tweet.text} {tweet.emoji}
        {tweet.hashtags &&
        tweet.hashtags.filter((tag) => tag.trim() !== "").length > 0
          ? tweet.hashtags
              .filter((tag) => tag.trim() !== "")
              .map((tag) => ` #${tag}`)
              .join("")
          : ""}
      </p>
      <div className="flex flex-row w-full justify-end mt-2">
        <span className="text-xs text-muted-foreground">{localDate}</span>
      </div>
    </div>
  );
};
